import { ChakraProvider } from "@chakra-ui/react";
import Header from "./BenAsensoCompo2/Components/Header";
import Home from "./BenAsensoCompo2/Home";

import Blog from "./BenAsensoCompo2/Pages/Blog";
import PrivacyPolicy from "./BenAsensoCompo2/Pages/PrivacyPolicy";
import NotFoundPage from "./BenAsensoCompo2/Pages/NotFoundPage";

import Footer from "./BenAsensoCompo2/Components/Footer";
import { Routes, Route, Router } from "react-router-dom";

//mine
import React, {useState, Suspense, lazy} from 'react'
import BitcoinBlog from "./BenAsensoCompo2/Blogs/BitcoinBlog";
import BearsBlog from "./BenAsensoCompo2/Blogs/BearsBlog";
import SignalsBlog from "./BenAsensoCompo2/Blogs/SignalsBlog";
import InvestorBlog from "./BenAsensoCompo2/Blogs/InvestorBlog";

import {HelmetProvider} from "react-helmet-async"
import { createTheme, ThemeProvider } from "@mui/material";




function App() {
  
  let theme = createTheme()


  let [selected, setSelected] = useState("Home")


  //Creating toggle for background switch
  let [toggle, setToggle] = useState(false)
  


  return(
    <div style={{"--header-height": "56px"}}>
      <ThemeProvider theme={theme}>

       <ChakraProvider>

          <HelmetProvider>
          <Header toggleProp={toggle} setToggle={setToggle} selected={selected} setSelected={setSelected}/>

          <Routes>
         
         <Route path="/" element={<Home  toggleProp={toggle} selected={selected} setSelected={setSelected} toggle={toggle} setToggle={setToggle} />} />

          <Route path="/blog" element={<Blog  toggleProp={toggle} setToggle={setToggle} setSelected={setSelected} />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy toggleProp={toggle} setToggle={setToggle} />} />
          <Route path="/blog/bitcoin-jumps-to-highest-since-august" element={<BitcoinBlog  toggleProp={toggle} setToggle={setToggle} />} />
          <Route path="/blog/the-bears-come-back-to-bother-the-bulls" element={<BearsBlog  toggleProp={toggle} setToggle={setToggle} />} />
          <Route path="/blog/conflicting-signals-erratic-movements" element={<SignalsBlog  toggleProp={toggle} setToggle={setToggle} />} />
          <Route path="/blog/investor-optimism-is-about-to-be-tested" element={<InvestorBlog  toggleProp={toggle} setToggle={setToggle} />} />

          <Route path="*" element={<NotFoundPage toggleProp={toggle} setToggle={setToggle} />} />


          </Routes>

          <Footer />
          </HelmetProvider>
      
    </ChakraProvider>
    </ThemeProvider>

    </div>
  )
}

export default App;
